import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { PlusCircle, Euro, MapPin, Clock, Users } from "lucide-react";

export default function FacilityHome() {
    const [jobs, setJobs] = useState([]);
    const [stats, setStats] = useState({ jobs: 0, apps: 0, collabs: 0 });
    const nav = useNavigate();

    useEffect(() => {
        (async () => {
            const [j, a, c] = await Promise.all([
                api.get("/jobs?mine=true"),
                api.get("/applications"),
                api.get("/collaborations"),
            ]);
            setJobs(j.data.data || []);
            setStats({
                jobs: j.data.data?.length || 0,
                apps: a.data.data?.length || 0,
                collabs: c.data.data?.length || 0,
            });
        })();
    }, []);

    return (
        <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-6">
                <div>
                    <h1 className="font-display text-3xl font-bold tracking-tight">I tuoi annunci</h1>
                    <p className="text-sm text-[#5C5C5C] mt-1">Gestisci turni e opportunità</p>
                </div>
                <Link to="/app/annunci/nuovo">
                    <Button className="bg-[#1C3F39] hover:bg-[#2A5C53]" data-testid="new-job-btn"><PlusCircle className="w-4 h-4 mr-2" />Nuovo annuncio</Button>
                </Link>
            </div>

            <div className="grid md:grid-cols-3 gap-4 mb-8">
                {[
                    { label: "Annunci pubblicati", value: stats.jobs, testid: "kpi-jobs" },
                    { label: "Candidature ricevute", value: stats.apps, testid: "kpi-apps" },
                    { label: "Collaborazioni", value: stats.collabs, testid: "kpi-collabs" },
                ].map((k, i) => (
                    <div key={i} className="hl-card p-6" data-testid={k.testid}>
                        <div className="text-xs text-[#5C5C5C] uppercase tracking-wide">{k.label}</div>
                        <div className="font-display text-4xl font-bold text-[#1C3F39] mt-2 font-mono">{k.value}</div>
                    </div>
                ))}
            </div>

            <div className="grid md:grid-cols-2 gap-4">
                {jobs.length === 0 && (
                    <div className="hl-card p-10 text-center col-span-full">
                        <div className="font-display text-xl">Nessun annuncio</div>
                        <div className="text-sm text-[#5C5C5C] mt-2">Crea il primo per iniziare a ricevere candidature.</div>
                    </div>
                )}
                {jobs.map((j) => (
                    <div key={j.id} className="hl-card p-6" data-testid={`facility-job-${j.id}`}>
                        <div className="flex items-start justify-between">
                            <div>
                                <span className="hl-pill">{j.profession}</span>
                                <h3 className="mt-3 font-display text-lg font-bold">{j.title}</h3>
                            </div>
                            <Badge variant="outline">{j.status}</Badge>
                        </div>
                        <div className="mt-4 space-y-1 text-sm text-[#5C5C5C]">
                            <div className="flex items-center gap-2"><MapPin className="w-4 h-4" />{j.city}</div>
                            <div className="flex items-center gap-2"><Clock className="w-4 h-4" />{j.date} · {j.start_time}–{j.end_time}</div>
                            <div className="flex items-center gap-2 text-[#1A1A1A] font-semibold"><Euro className="w-4 h-4" /><span className="font-mono">{j.compensation_gross?.toFixed(2)}€</span> lordo</div>
                        </div>
                        <div className="mt-4 flex gap-2">
                            <Button variant="outline" size="sm" onClick={() => nav(`/app/job/${j.id}`)} data-testid={`view-job-${j.id}`}>Dettagli</Button>
                            <Button size="sm" onClick={() => nav("/app/candidature-ricevute")} className="bg-[#1C3F39] hover:bg-[#2A5C53]" data-testid={`view-apps-${j.id}`}>
                                <Users className="w-4 h-4 mr-2" />Candidature
                            </Button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
